import React from 'react';
import Row from '../Row';
import Container from './Container';
import AlarmIcon from './AlarmIcon';
import Content from './Content';

export default ({ color, icon, children, ...rest }) => (
  <Container {...rest}>
    <Row cols="auto">
      <Content>
        <AlarmIcon color={color} name={icon} />
        {children}
      </Content>
    </Row>
  </Container>
);
